<template>
  <!-- <template v-if="slides.length"> -->
    <router-view />
  <!-- </template> -->
  <!-- <FullscreenSpin tip="数据初始化中，请稍等 ..." v-else  loading :mask="false" /> -->
</template>



<script lang="ts" setup>
import { onMounted, onUnmounted, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useAppStore } from '@/store/app'
import { useUserStore } from '@/store/user'
import { useInviteStore } from '@/store/invite'
import { useRouter, useRoute } from 'vue-router'
import { isPC } from '@/utils/common'
import { envConfig } from '@/configs/env'
import { getAndrioInfo, getIOSInfo, getQueryParam, isMobile, reportEvent, isValidIOSNativeInfo, shouldSkipIOSNativeBridge, markIOSNativeSession, fetchIOSTabBarHeight, isMiniAppWebview, syncMiniAppTokenFromQuery, getToken, getMiniAppDeviceParams } from '@/utils/auth.ts'
import { getDeviceId } from '@/utils/device'
import * as UserApi from '@/api/user.ts'
import {
  handleNativeTabSwitch,
  OUTLINE_DRAFT_STORAGE_KEY,
} from '@/utils/createDraftCache'
import { ACTIVITY_LOCATION, normalizeActivityLocation } from '@/utils/activityLocation'

const userStore = useUserStore()
const appStore = useAppStore()
const inviteStore = useInviteStore()
const { userInfo } = storeToRefs(userStore)

const route = useRoute()
const router = useRouter()
// if (import.meta.env.MODE !== 'development' && !isMobile()) {
//   window.onbeforeunload = () => false
// }

const safeCollectEvent = (eventName: string, payload: Record<string, unknown>) => {
  if (typeof window.collectEvent === 'function') {
    window.collectEvent(eventName, payload)
  }
}

const applyMiniAppAnalyticsProfile = (shortId = '') => {
  if (!isMiniAppWebview()) return
  const uid = shortId || userInfo.value?.shortId || ''
  if (uid) {
    safeCollectEvent('config', {
      user_unique_id: uid,
    })
  }
  safeCollectEvent('profileSet', {
    deviceType: '微信小程序',
    userId: uid,
    prod_name: '1dppt',
  })
}

const token = localStorage.getItem('ydppt_token')
const setCollectEvent = ()=>{
  if(!isMobile() && token){
    setTimeout(() => {
      // 添加用户id
      safeCollectEvent('config', { 
           user_unique_id: userInfo.value.shortId,
         })
       safeCollectEvent('profileSet', {
         deviceType:'WEB',
         userId: userInfo.value.shortId, //添加用户id
         prod_name:'1dppt',
      });
     }, 300);
  }
}
const AndroInfo = ()=>{
  try {
    if (isMiniAppWebview()) {
      appStore.setAndrioInfo({
        ...getMiniAppDeviceParams(),
        token: getToken() || '',
      })
      applyMiniAppAnalyticsProfile()
      return
    }
    if (window.JsAndroid) {
      const data = getAndrioInfo();
      appStore.setAndrioInfo(data);
      // console.log('AndrioInfo:', data);
      // 添加用户id
      reportEvent('config', { 
        userId: data.uid
      });
      safeCollectEvent('profileSet', { 
        userId: data.uid, //添加用户id
       })
      reportEvent('profileSet', {
          deviceType:'Android',
      });
    } else if(window.prompt && !isMiniAppWebview()) {
      const currentPath = router.currentRoute.value.path
      if (shouldSkipIOSNativeBridge(currentPath)) {
        window.prompt = null
        return
      }
      setTimeout(()=>{
        const path = router.currentRoute.value.path
        if (shouldSkipIOSNativeBridge(path)) {
          window.prompt = null
          return
        }
        const data = getIOSInfo(path);
        // console.log(data)
        // 非 App WebView（如 Safari）：拿不到 platform=IOS，置空 prompt 避免协议页误判
        // 判断是否为iOS原生端
        if (!isValidIOSNativeInfo(data)) {
          window.prompt = null
          return
        }
        markIOSNativeSession()
        appStore.setAndrioInfo(data);
        const tabHeight = fetchIOSTabBarHeight()
        if (tabHeight != null) {
          appStore.setTabBarHeight(tabHeight)
        }
          // 添加用户id
          reportEvent('config', { 
            userId: data.uid || ''
          });
        safeCollectEvent('profileSet', { 
          userId: data.uid || '', //添加用户id
        })
          reportEvent('profileSet', {
              deviceType:'IOS',
          });
      },500)
    }
  } catch (e) {
    // console.warn('调用 JsAndroid 失败:', e.message);
  }
}

const getUser = ()=>{
  import('@/api/user.ts').then(({ getUserInfo }) => getUserInfo({})).then(res=>{
    if(res.code === 'SUCCESS'){
      userStore.setUserInfo(res.data)
      const shortId = res.data?.shortId
      if (shortId && !isMobile()) {
        safeCollectEvent('profileSet', {
          userId: shortId,
          prod_name:'1dppt',
        })
      }
      if (isMiniAppWebview()) {
        applyMiniAppAnalyticsProfile(shortId || '')
      }
    }
  })
}

//针对原生端返回方法
window.goBack = function() {
  window.ToolsBcak()
}

//针对原生端切tab
window.switchTab = function(tab?: string) {
  handleNativeTabSwitch(tab)
  if (window.getProduction) {
    window.getProduction()
  }
}

let sdkModalRequesting = false
let sdkModalRequestingLocation: string | null = null
let sdkModalPendingLocation: string | null = null
let activeSdkModalLocation = ACTIVITY_LOCATION.HOME
const sdkModalLastRequestedAt: Record<string, number> = {}

const openSdkModalWebview = (url: string) => {
  const modalUrl = encodeURIComponent(url)
  if ((window as any).JsAndroid) {
    window.location.href = 'ydppt://webful?url=' + modalUrl + '&w=318&h=520&modal=true&dim=true&closeBtn=false'
    return true
  }
  if (window.prompt) {
    window.location.href = 'ydppt://webful?url=' + modalUrl + '&w=318&h=520&modal=false&dim=true&closeBtn=false'
    return true
  }
  return false
}

// 原生打开活动弹窗
window.openSdkModal = async function(location = ACTIVITY_LOCATION.HOME) {
  const modalLocation = normalizeActivityLocation(location)
  activeSdkModalLocation = modalLocation
  const now = Date.now()
  const lastRequestedAt = sdkModalLastRequestedAt[modalLocation] || 0
  if (sdkModalRequesting) {
    sdkModalPendingLocation = sdkModalRequestingLocation === modalLocation ? null : modalLocation
    return false
  }
  if (now - lastRequestedAt < 1000) return false

  sdkModalRequesting = true
  sdkModalRequestingLocation = modalLocation
  sdkModalLastRequestedAt[modalLocation] = now
  try {
    const res = await UserApi.getModalListByLocation({
      params: {
        location: modalLocation
      }
    })
    const modalList = Array.isArray(res?.data) ? res.data : []
    if (res?.code !== 'SUCCESS' || modalList.length === 0) return false
    if (modalLocation !== activeSdkModalLocation) return false

    const activityInfo = {
      location: modalLocation,
      modalList
    }
    appStore.setActivityInfo(activityInfo)
    localStorage.setItem('activityInfo', JSON.stringify(activityInfo))

    const url = `${window.location.origin}/activities?location=${encodeURIComponent(modalLocation)}`
    return openSdkModalWebview(url)
  } catch {
    return false
  } finally {
    setTimeout(() => {
      sdkModalRequesting = false
      sdkModalRequestingLocation = null
      const pendingLocation = sdkModalPendingLocation
      sdkModalPendingLocation = null
      if (pendingLocation && pendingLocation === activeSdkModalLocation) {
        window.openSdkModal?.(pendingLocation)
      }
    }, 1000)
  }
}

window.openMySdkModal = function() {
  return window.openSdkModal(ACTIVITY_LOCATION.MINE)
}

//登录状态发生变化
window.loginStateChanged = function(isLogin){
  console.log('loginStateChanged', isLogin)
  if(isLogin){
    AndroInfo()
    getUser()
    window.openSdkModal?.(ACTIVITY_LOCATION.HOME)
  }
  if(window.getProduction){
    window.getProduction()
  }
  if(window.getHome){
    window.getHome()
  }
  //这个是ios临时在会员页监听登录成功方法
  if(window.iosLinCatarog){
    window.iosLinCatarog()
  }
}


// 统一处理“充值成功”的逻辑（localStorage 标记 + 页面级回调）
const handleRechargeSuccess = () => {
  const flag = localStorage.getItem('rechargeSuccess')
  if (!flag) return

  // 全局刷新用户信息
  getUser()
  // 用一次就清掉，避免重复触发
  setTimeout(()=>{
    localStorage.removeItem('rechargeSuccess')
  },1000)
}

//设置根节点字体大小
const setRem = ()=>{
  const doc = document.documentElement;
  const baseSize = 16; // PC 默认字体大小
  const scale = doc.clientWidth / 1920; // PC 宽度比例
  // 判断是否为移动端
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  if (isMobile) {
    // 设置移动端字体大小
    const mobileBaseSize = 375; // 移动端默认字体大小
    const mobileScale = doc.clientWidth / mobileBaseSize;
    doc.style.fontSize = baseSize * mobileScale + 'px';
    doc.style.scrollbarWidth = 'none'
  } else {
    // PC 设置字体大小
    doc.style.fontSize = baseSize * Math.min(scale, 2) + 'px';
  }
}


// storage 事件：用于监听“其它 WebView / 窗口”写入的充值标记
const handleStorageChange = (e: StorageEvent) => {
  if (e.key === 'rechargeSuccess' && e.newValue) {
    handleRechargeSuccess()
  }
  if (e.key === OUTLINE_DRAFT_STORAGE_KEY && e.newValue) {
    handleNativeTabSwitch()
  }
}

const handleVisibilityChange = () => {
  if (document.visibilityState === 'visible') {
    handleNativeTabSwitch()
  }
}


onMounted(async () => {
  // const slides = await api.getMockData('slides')
  // slidesStore.setSlides(slides)

  document.title = envConfig.appTitle
  inviteStore.cacheInviteCodeFromCurrentUrl(route.query.code || route.query.inviteCode)
  const miniToken = syncMiniAppTokenFromQuery()
  // 小程序未登录（URL token 为空）时，同步清掉 H5 用户态
  if (isMiniAppWebview() && !miniToken) {
    userStore.logout()
    appStore.setAndrioInfo({ token: '' })
  }

  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  if(isMobile()){
    if(!isIOS){
      if (!isMiniAppWebview()) {
        window.prompt = null;
      }
      AndroInfo();
    } else if (shouldSkipIOSNativeBridge(route.path)) {
      // window.prompt = null;
    } else {
      AndroInfo();
    }
    // 小程序已登录时拉用户信息并绑定埋点 userId
    if (isMiniAppWebview() && (miniToken || getToken())) {
      getUser()
    }
  } else {
    window.prompt = null;
    getDeviceId()
    setCollectEvent()
  }
  
  // 初始化编辑器和移动端页面
  if (route.path === '/editor' || route.path === '/mobile') {
    const [{ deleteDiscardedDB }, { useSnapshotStore }] = await Promise.all([
      import('@/utils/database'),
      import('@/store/snapshot'),
    ])
    await deleteDiscardedDB()
    useSnapshotStore().initSnapshotDatabase()
  }

  // setRem();
  // window.addEventListener('resize', setRem);

  // 处理移动端页面逻辑
  if (isMobile()) {
    window.addEventListener('storage', handleStorageChange);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // 处理充值成功逻辑
    handleRechargeSuccess()
  }
})

// 处理iOS桥接路由策略
const applyIOSBridgeRoutePolicy = (path: string) => {
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
  if (!isMobile() || !isIOS || isMiniAppWebview()) return
  if (shouldSkipIOSNativeBridge(path)) {
    window.prompt = null
  }
}

watch(
  () => route.path,
  (path) => applyIOSBridgeRoutePolicy(path),
)

onUnmounted(() => {
  if (isMobile()) {
    window.removeEventListener('storage', handleStorageChange);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  }
  // window.removeEventListener('resize', setRem);
})

</script>

<style lang="scss">
#app {
  height: 100%;
}
// @media screen and (min-width: 768px) {
    /* 默认使用默认字体大小*/
  body {
    font-weight: 500; /* 默认使用默认字体大小 */
  }
  @font-face {
    font-family: 'GwbFont';
    src: url('./assets/fonts/AlibabaPuHuiTi-Light.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'GwbFont';
    // src: url('https://ptos.1dppt.com/web/fonts/Alibaba-PuHuiTi-Regular-CdxnY8Z2.woff2') format('woff2');
    src: url('./assets/fonts/Alibaba-PuHuiTi-Regular.ttf') format('truetype');
    font-weight: 500; 
    font-style: normal;
    font-display: swap;
  }
  
  @font-face {
    font-family: 'GwbFont';
    src: url('./assets/fonts/Alibaba-PuHuiTi-Medium.ttf') format('truetype');
    font-weight: 600; 
    font-style: normal;
    font-display: swap;
  }
// }
</style>

